module.exports = __webpack_public_path__ + "static/media/roy_0.3b8e4388.png";